.buttons {
  display: flex;
  padding: 5px 20px;
  width: 230px;
}
